import { Recipe } from "@/types/recipe";
import { Timestamp } from "firebase/firestore";

const now = Timestamp.now();

export const SAMPLE_RECIPES: Recipe[] = [
  {
    id: '1',
    title: 'Homemade Pizza',
    description: 'Classic Italian pizza with fresh toppings',
    images: ['https://images.unsplash.com/photo-1565299624946-b28f40a0ae38'],
    chef: 'Mario Chef',
    date: '2024-02-20',
    cookTime: '45 min',
    difficulty: 'medium',
    cookingMethods: ['baking'],
    cuisine: 'Italian',
    dishTypes: ['main'],
    ingredients: [],
    instructions: [],
    steps: [],
    totalTime: '45',
    servings: { amount: 4, unit: 'servings' },
    dietaryInfo: {
      isVegetarian: true,
      isVegan: false,
      isGlutenFree: false,
      isDairyFree: false,
      containsNuts: false
    },
    categories: ['comfort food'],
    equipment: [],
    featuredImageIndex: 0,
    tags: [],
    worksWith: [],
    serveWith: [],
    estimatedCost: 'Under $5',
    season: 'Year Round',
    occasion: '',
    createdAt: now,
    updatedAt: now,
    status: 'published',
    stats: {
      views: 0,
      likes: [],
      saves: [],
      comments: 0
    }
  },
  {
    id: '2',
    title: 'Fresh Sushi Roll',
    description: 'Traditional Japanese sushi rolls',
    images: ['https://images.unsplash.com/photo-1579871494447-9811cf80d66c'],
    chef: 'Yuki Chef',
    date: '2024-02-21',
    cookTime: '30 min',
    difficulty: 'hard',
    cookingMethods: ['rolling'],
    cuisine: 'Japanese',
    dishTypes: ['main'],
    ingredients: [],
    instructions: [],
    steps: [],
    totalTime: '30',
    servings: { amount: 2, unit: 'servings' },
    dietaryInfo: {
      isVegetarian: false,
      isVegan: false,
      isGlutenFree: true,
      isDairyFree: true,
      containsNuts: false
    },
    categories: ['seafood'],
    equipment: [],
    featuredImageIndex: 0,
    tags: [],
    worksWith: [],
    serveWith: [],
    estimatedCost: 'Under $5',
    season: 'Year Round',
    occasion: '',
    createdAt: now,
    updatedAt: now,
    status: 'published',
    stats: {
      views: 0,
      likes: [],
      saves: [],
      comments: 0
    }
  },
  {
    id: '3',
    title: 'Healthy Buddha Bowl',
    description: 'Nutritious and colorful vegetarian bowl',
    images: ['https://images.unsplash.com/photo-1546069901-ba9599a7e63c'],
    chef: 'Sarah Wellness',
    date: '2024-02-22',
    cookTime: '20 min',
    difficulty: 'easy',
    cookingMethods: ['assembly'],
    cuisine: 'International',
    dishTypes: ['main'],
    ingredients: [],
    instructions: [],
    steps: [],
    totalTime: '20',
    servings: { amount: 1, unit: 'serving' },
    dietaryInfo: {
      isVegetarian: true,
      isVegan: true,
      isGlutenFree: true,
      isDairyFree: true,
      containsNuts: true
    },
    categories: ['healthy'],
    equipment: [],
    featuredImageIndex: 0,
    tags: [],
    worksWith: [],
    serveWith: [],
    estimatedCost: 'Under $5',
    season: 'Year Round',
    occasion: '',
    createdAt: now,
    updatedAt: now,
    status: 'published',
    stats: {
      views: 0,
      likes: [],
      saves: [],
      comments: 0
    }
  }
];